// The API caps a whole upload request at 100MB (UploadLimits.MaxUploadBytes), not each file.
// Leave room for the multipart framing so a selection right at the limit isn't refused with a 413.
export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024 - 256 * 1024;

/**
 * Keeps files, in the order picked, while they fit in one request of maxTotalBytes. A file that
 * would take it over is skipped rather than ending the run, so photos picked after a big video
 * still go up. Rejected files come back so the picker can say which ones didn't make it.
 */
export const takeWithinTotal = <T extends { size: number }>(files: T[], maxTotalBytes: number) => {
  const accepted: T[] = [];
  const rejected: T[] = [];
  let total = 0;

  for (const file of files) {
    if (total + file.size > maxTotalBytes) {
      rejected.push(file);
      continue;
    }

    total += file.size;
    accepted.push(file);
  }

  return { accepted, rejected };
};
